export class XpoAuthSwitchApiConfig {
  apiUri: string;
}
